module.exports = __webpack_public_path__ + "static/dvs-ecc2c8a7e6878390c3e579936325795d.jpg";